var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { TypeActionPurchasePointsEventInfo, } from "./actionPurchasePointsEventInfo";
var initial = {
    purchasePoints: Long.ZERO,
    showPurchasePointsHudButton: true,
};
export var reducerPurchasePointsEventInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionPurchasePointsEventInfo.Received:
            if (action.purchasePoints && action.purchasePoints.points) {
                return __assign({}, state, { purchasePoints: action.purchasePoints.points });
            }
            break;
        case TypeActionPurchasePointsEventInfo.HideHudButton:
            return __assign({}, state, { showPurchasePointsHudButton: false });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/purchase-points-event/reducerPurchasePointsEventInfo.ts
// module id = 2971
// module chunks = 3